/**
 * @generated SignedSource<<56b76a1b90db6ec2b0abdb4176038577>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getShoppablePhotoData_searchBrowsePhoto$data = {
  readonly creators: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_creators">;
  } | null> | null;
  readonly tags: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_tags">;
  } | null> | null;
  readonly " $fragmentType": "getShoppablePhotoData_searchBrowsePhoto";
};
export type getShoppablePhotoData_searchBrowsePhoto$key = {
  readonly " $data"?: getShoppablePhotoData_searchBrowsePhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_searchBrowsePhoto">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getShoppablePhotoData_searchBrowsePhoto"
};

(node as any).hash = "0c7277ae5b83dd2903c13203c95eb225";

export default node;
